export function linkificar(texto) {
    const regex = /https?:\/\/[^\s]+/gi
    const partes = texto.split(regex)
    const urls = texto.match(regex) || []

    return partes.map((parte, i) => (
        <span key={i}>
        {parte}
        {urls[i] && (
            <a href={urls[i]} target="_blank" rel="noopener noreferrer">
            {urls[i]}
            </a>
        )}
        </span>
    ))
}